import { EmailDraftDataDto, EmailSendModeDto } from '@/api/generated';
import { NewEmailFormModel } from '@/components/emailWindow/model/NewEmailForm.model.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

export const useMapNewEmailToUpdateDraft = () => {
  const { email } = useUserContext();

  return {
    mapNewEmailToUpdateDraft: (params: {
      form: NewEmailFormModel;
      onEmailId?: string;
      sendMode: EmailSendModeDto;
    }): EmailDraftDataDto => {
      const { form, onEmailId, sendMode } = params;
      return {
        bcc: form.bcc.map(it => it.email),
        body: form.body,
        cc: form.cc.map(it => it.email),
        from: email,
        onEmailId,
        sendMode,
        subject: form.subject,
        to: form.to.map(it => it.email),
      };
    },
  };
};
